import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

export function GenericPropertyIcon({ className }: SimpleIconInterface) {
  const maskId = useSvgId('generic-property-mask');

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="16"
      viewBoxDimensions="0 0 16 16"
      width="16"
    >
      <g opacity="0.8">
        <mask
          height="16"
          id={maskId}
          maskUnits="userSpaceOnUse"
          style={{ mask: 'alpha' }}
          width="16"
          x="0"
          y="0"
        >
          <rect fill="#D9D9D9" height="16" width="16" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M2.6665 12.6654V11.332H9.33317V12.6654H2.6665ZM2.6665 9.9987V8.66536H13.3332V9.9987H2.6665ZM2.6665 7.33203V5.9987H13.3332V7.33203H2.6665ZM2.6665 4.66536V3.33203H13.3332V4.66536H2.6665Z"
            fill="#324A52"
          />
        </g>
      </g>
    </SimpleIcon>
  );
}
